import { Component, Input } from '@angular/core';
import { KnowledgePanelService } from '../../services/knowledge-service/knowledge-panel.service';

@Component({
  selector: 'help-button',
  templateUrl: './help-button.component.html',
  styleUrls: ['./help-button.component.scss']
})
export class HelpButtonComponent {
  @Input() helpId?: string;
  @Input() contextKey?: string;

  constructor(private panelService: KnowledgePanelService) {}

  open(): void {
    if (this.contextKey) {
      this.panelService.open(this.contextKey);
    } else if (this.helpId) {
      this.panelService.openById(this.helpId);
    }
  }
}
